import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';

import { ArchivoForm } from './components/Archivo';

export const MultiFileUpdate = ({ name, onFormsChange, reset, value }) => {

    const [elements, setElements] = useState((typeof value !== 'undefined') ? value.map(val => ({ id: val._id, archivo: val.archivo, archivoName: val.archivoName })) : [])

    const handleRemoveElement = (id) => {
        setElements(elements.filter(archivo => archivo.id !== id));
    }

    useEffect(() => {
        onFormsChange({ target: { name: name, value: elements } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements])

    useEffect(() => {
        setElements((typeof value !== 'undefined') ? value.map(val => ({ id: val._id, archivo: val.archivo, archivoName: val.archivoName })) : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reset])

    return (
        <>
            {elements.map((element) => <ArchivoForm
                key={element.id}
                element={element}
                removeElement={handleRemoveElement}
            />)}
        </>
    )
}

MultiFileUpdate.propTypes = {
    name: PropTypes.string.isRequired,
    onFormsChange: PropTypes.func.isRequired,
    reset: PropTypes.number,
    value: PropTypes.array
}